import { render, staticRenderFns } from "./sharingConfig.template.vue?vue&type=template&id=085ade0b&scoped=true&"
var script = {}
import style0 from "./sharingConfig.template.vue?vue&type=style&index=0&id=085ade0b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ade0b",
  null
  
)

export default component.exports